const ArrowUpIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.55"
      height="18.742"
      viewBox="0 0 14.55 18.742"
    >
      <path
        id="icon"
        d="M469.913,227.323V212.942l-4.6,4.6a.988.988,0,0,1-1.4-1.4l6.287-6.287a.988.988,0,0,1,1.4,0l6.286,6.287a.988.988,0,1,1-1.4,1.4l-4.6-4.6v14.38a.988.988,0,1,1-1.975,0Z"
        transform="translate(-463.626 -209.569)"
      />
    </svg>
  );
};

export default ArrowUpIcon;
